var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-flex',{staticClass:"mb-4",attrs:{"mx-auto":""}},[_c('v-select',{staticClass:"px-3",attrs:{"persistent-hint":"","hint":"Select The Date For This Entry","items":_vm.dates,"single-line":"","color":"grey","item-value":"text"},on:{"change":function($event){_vm.updateCurrentDate($event)}},model:{value:(_vm.select),callback:function ($$v) {_vm.select=$$v},expression:"select"}})],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a7686faa","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/DateSelect.vue
// module id = null
// module chunks = 